import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { colorsPalette, shadows } from '../../../styles/colors';

export const tabsWrapper = css({
  position: 'relative',
});

export const tabsHeader = css({
  position: 'relative',
  backgroundColor: colorsPalette.white,
  boxShadow: shadows.shadow80,
  display: 'flex',
  overflowX: 'auto',
  position: 'relative',
  [MediaQueries.lgAndUp]: {
    overflowX: 'visible',
  },
});

export const shadowEffectLeft = css({
  height: '100%',
  pointerEvents: 'none',
  width: 60,
  left: '-1px',
  top: 0,
  position: 'absolute',
  background: `linear-gradient(90deg, ${colorsPalette.white} 0%, ${colorsPalette.white}00 100%)`,
});

export const shadowEffectRight = css({
  height: '100%',
  pointerEvents: 'none',
  width: 60,
  right: '-1px',
  top: 0,
  position: 'absolute',
  background: `linear-gradient(270deg, ${colorsPalette.white} 10%, ${colorsPalette.white}00 100%)`,
  [MediaQueries.lgAndUp]: {
    width: 0,
  },
});

export const tabsContent = css({
  marginTop: 46,
  [MediaQueries.md]: {
    marginTop: 72,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 104,
  },
});
